/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Previewer from "vux/src/components/previewer/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
export default {
  components: {
    Previewer: Previewer
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    extFields: {
      type: Array
    },
    imgViewType: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: 'h3',
      validator: function validator(e) {
        return ['h1', 'h2', 'h3', 'h4'].includes(e);
      }
    },
    level: {
      type: String,
      default: 'normal',
      validator: function validator(e) {
        return ['normal', 'large'].includes(e);
      }
    }
  },
  data: function data() {
    return {
      picList: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var $$ = document.querySelectorAll.bind(document);
          var thumbnail = $$('.previewer-demo-img')[index];

          if (thumbnail) {
            var _thumbnail = $$('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();

              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        },
        shareEl: true,
        shareButtons: [{
          id: 'download',
          label: ' 下载图片 ',
          url: '{{raw_image_url}}',
          download: true
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['config'])), {}, {
    defaultClass: function defaultClass() {
      return ["font-size-".concat(this.size, "-").concat(this.level)];
    }
  }),
  methods: {
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    },
    translate: function translate(str) {
      return str.slice(str.indexOf('-') + 1);
    },
    imgClick: function imgClick(extField, index) {
      var _this = this;

      this.picList = extField.tfvvalue.split(',').filter(function (item) {
        return item;
      }).map(function (item) {
        return {
          src: item
        };
      });
      this.$nextTick(function () {
        _this.$refs.previewer.show(index);
      });
    },
    getMessageFile: function getMessageFile(url, filename) {
      var _this2 = this;

      this.$DingTalk.device.notification.actionSheet({
        title: filename,
        // 标题
        cancelButton: '取消',
        // 取消按钮文本
        otherButtons: ['保存到钉盘', '附件下载', '附件预览'],
        onSuccess: function onSuccess(result) {
          if (result.buttonIndex === 0) {
            _this2.$DingTalk && _this2.$DingTalk.biz.cspace.saveFile({
              corpId: _this2.config.corpId,
              url: url,
              // 文件在第三方服务器地址， 也可为通过服务端接口上传文件得到的media_id，详见参数说明
              name: filename,
              onSuccess: function onSuccess(data) {
                _this2.$vux.toast.text('保存成功');
              },
              onFail: function onFail(err) {
                _this2.$vux.toast.text('保存失败');

                console.log(err);
              }
            });
          } else if (result.buttonIndex === 1) {
            _this2.$DingTalk && _this2.$DingTalk.biz.util.openLink({
              url: url,
              onSuccess: function onSuccess(res) {
                _this2.$vux.toast.text('下载成功');
              },
              onFail: function onFail(err) {
                _this2.$vux.toast.text('下载失败');

                console.log(err);
              }
            });
          } else if (result.buttonIndex === 2) {
            _this2.preview(url);
          }
        },
        onFail: function onFail(err) {
          console.log(err);
        }
      });
    },
    preview: function preview(url) {
      this.$router.push({
        name: 'Preview',
        query: {
          url: url
        }
      }); // const url = `${previewUrl}?url=${encodeURIComponent(item)}`
      // try {
      //   this.$DingTalk.biz.util.openLink({
      //     url: url,
      //     onSuccess: res => {},
      //     onFail: err => {
      //       this.$vux.toast.text('打开预览失败')
      //       console.log(err)
      //     }
      //   })
      // } catch (error) {
      //   window.open(url, '_blank')
      // }
    }
  }
};